import http from '@util/http';
import {incubator} from '@api/req';

export async function queryInvoiceList(params) {
  return http.get(incubator.INVOICE_LIST, params);
}

export async function queryInvoiceMy(params) {
  return http.get(incubator.INVOICE_MY, params);
}

export async function queryInvoiceInfo(params) {
  return http.get(incubator.INVOICE_INFO, params);
}

export async function queryInvoiceSave(params) {
  return http.post(incubator.INVOICE_SAVE, params);
}

// 出纳办理特殊为post
export async function queryInvoiceNext(params) {
  return params.uuid
    ? http.post(incubator.INVOICE_NEXT, params)
    : http.get(incubator.INVOICE_NEXT, params);
}

export async function queryInvoiceReturn(params) {
  return http.post(incubator.INVOICE_RETURN, params);
}

export async function queryInvoiceCallback(params) {
  return http.get(incubator.INVOICE_CALLBACK, params);
}

export async function queryInvoiceDelete(params) {
  return http.get(incubator.INVOICE_DELETE, params);
}

export async function queryInvoiceInvalid(params) {
  return http.post(incubator.INVOICE_INVALID, params);
}

export async function queryInvoiceWorkflow(params) {
  return http.get(incubator.INVOICE_WORKFLOW, params);
}

export async function queryIncuAvailable(params) {
  return http.get(incubator.INVOICE_INCU_AVAILABLE, params);
}

export async function queryCustomAvailable(params) {
  return http.get(incubator.INVOICE_CUSTOM_AVAILABLE, params);
}

export async function queryCustomDoing(params) {
  return http.get(incubator.INVOICE_CUSTOM_DOING, params);
}

export async function queryCustomInvoiceTodo(params) {
  return http.get(incubator.INVOICE_CUSTOM_TODO, params);
}



// WEBPACK FOOTER //
// ./src/api/incubator/invoice.js